import React from 'react';
import Container from '@material-ui/core/Container';
import './Hardware.css';

export default function HardwareStats() {
 return(
  <Container className="header-root" maxWidth="xl">
   <h1 className="notification-heading">Hardware Statistics</h1>
  </Container>
 );
}